module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_WoodMatted_MockedUp.a345c73b.jpg";